import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'anf-core-react';
import CreditCardInput from '../Common/CreditCardInput/CreditCardInput';
import ExpiryField from './ExpiryField';
import CVVField from './CVVField';
import AddressForm from './AddressForm';

// TODO: this is a placeholder for now
// eslint-disable-next-line no-unused-vars
function WssPaymentUpdateForm({ orderNumber: _orderNumber, wssPaymentDetails }) {
  const [useShippingAddress, setUseShippingAddress] = useState(true);
  const [formState, setFormState] = useState({
    cardNumber: '',
    expirationDate: '',
    securityCode: '',
  });

  const handleUpdate = () => {
    // TODO: Implement mutation call using _orderNumber and formState
    // console.log('Order number for mutation:', _orderNumber);
  };

  const {
    updateCardInformationTitle = {},
    billingAddressTitle = {},
    billToShippingAddressLabel = {},
    updateButtonText = {},
    creditCardFormText = {},
    shippingAddress = {},
  } = wssPaymentDetails || {};

  return (
    <div className="wss-payment-update-form">
      <h3>{updateCardInformationTitle?.value || ''}</h3>
      <div className="credit-card-fields">
        <CreditCardInput
          label={creditCardFormText?.cardNumberLabel?.value || ''}
          isInvalid={!!(creditCardFormText?.cardNumberError?.value)}
          cardNumError={creditCardFormText?.cardNumberError || {}}
          name="cardNumber"
          type="tel"
          isDisabled={false}
          value={formState.cardNumber}
          onChange={(val) => setFormState({ ...formState, cardNumber: val })}
        />
        <div className="expiration-cvv-row">
          <ExpiryField
            label={creditCardFormText?.expirationDateLabel?.value || ''}
            errorMessage={creditCardFormText?.expirationDateError?.value || ''}
            expiryDate={formState.expirationDate}
            index={0}
            onChange={(val) => setFormState({ ...formState, expirationDate: val })}
            hasValidationError={false}
          />
          <CVVField
            label={creditCardFormText?.securityCodeLabel?.value || ''}
            errorMessage={creditCardFormText?.securityCodeError?.value || ''}
            cvv={formState.securityCode}
            index={0}
            onChange={(val) => setFormState({ ...formState, securityCode: val })}
            hasValidationError={false}
            cardBrand=""
            tooltipImage=""
            tooltipMessage=""
          />
        </div>
      </div>

      <div className="billing-address-section">
        <h3>{billingAddressTitle?.value || ''}</h3>
        <label htmlFor="bill-to-shipping">
          <input
            id="bill-to-shipping"
            type="checkbox"
            checked={useShippingAddress}
            onChange={() => setUseShippingAddress(!useShippingAddress)}
          />
          {billToShippingAddressLabel?.value || ''}
        </label>
        {!useShippingAddress && (
          <AddressForm
            countryId={shippingAddress?.country || 'US'}
            address={shippingAddress}
            type="billing"
            onChange={(/* key, val */) => {
              // TODO: Handle address change
            }}
            // addressConfig will come from BFF
          />
        )}
      </div>

      <Button onClick={handleUpdate}>
        {updateButtonText?.value || ''}
      </Button>
    </div>
  );
}

WssPaymentUpdateForm.propTypes = {
  orderNumber: PropTypes.string.isRequired,
  wssPaymentDetails: PropTypes.shape({
    updateCardInformationTitle: PropTypes.shape({ value: PropTypes.string }),
    billingAddressTitle: PropTypes.shape({ value: PropTypes.string }),
    billToShippingAddressLabel: PropTypes.shape({ value: PropTypes.string }),
    updateButtonText: PropTypes.shape({ value: PropTypes.string }),
    creditCardFormText: PropTypes.shape({
      cardNumberLabel: PropTypes.shape({ value: PropTypes.string }),
      cardNumberError: PropTypes.shape({ value: PropTypes.string }),
      expirationDateLabel: PropTypes.shape({ value: PropTypes.string }),
      expirationDateError: PropTypes.shape({ value: PropTypes.string }),
      securityCodeLabel: PropTypes.shape({ value: PropTypes.string }),
      securityCodeError: PropTypes.shape({ value: PropTypes.string }),
    }),
    shippingAddress: PropTypes.shape({
      country: PropTypes.string,
    }),
  }).isRequired,
};

WssPaymentUpdateForm.defaultProps = {
};

export default WssPaymentUpdateForm;
